define('views/modules/template/edit/calendar/nutrition/nutrition-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // services
    'services/viewport',
    'services/layout',
    'services/nutrition/entry-tag',
    'services/nutrition/nutrients',
    'services/events/nutrition-events',
    // model
    'models/calendar/item/nutrition',
    // views
    'views/modules/template/edit/calendar/template-calendar-item-panel',
    'views/modules/template/edit/calendar/nutrition/nutrition-edit-content',
    'views/modules/calendar/favorite/favorite-content'

], function(
    // Libs
    _, Backbone, U,
    // services
    Viewport,
    LayoutState,
    EntryTagService,
    NutrientService,
    NutritionEvents,
    // models
    MNutrition,
    // parent view
    VTemplateCalendarItemPanel,
    // views
    VTemplateNutritionEditContent,
    VFavoriteContent
) {

    var VTemplateNutritionPanel = VTemplateCalendarItemPanel.extend({
        header: {
            title: "calendar:Nutrition Log",
            subtitle: "calendar:Your daily nutrition log",
        },
        content: {
            details: VTemplateNutritionEditContent,
            favorite: VFavoriteContent
        },

        initialize: function(opt) {
            this.model = new MNutrition();
        },

        showFavorite: function() {
            this.showContent('favorite', {
                type: 'nutrilog',
                model: this.view.details.model
            });

            NutritionEvents.refreshPanel();
        },

        showDetails: function() {
            VTemplateNutritionPanel.__super__.showDetails.apply(this, arguments);
            NutritionEvents.refreshPanel();
        },

        ////////////
        // events //
        ////////////
        onOpen: function(open) {
            var details = this.view.details;
            if (this.is(details) && !Viewport.isMobile() && this.model.isNew() && open) {
                details.toggleFoodPanel(true);
            }
        },

        // onExpandPanel: function() {
        //     if (LayoutState.isFull('info')) {
        //         LayoutState.toggleInfoFull();
        //     } else {
        //         this.view.details.toggleFoodPanel(true);
        //     }
        // },

        onModelReset: function() {
            return [
                EntryTagService.fetch(),
                NutrientService.fetch()
            ];
        },

        onSuccess: function() {
            VTemplateNutritionPanel.__super__.onSuccess.apply(this, arguments);
            this.close();
        },

    });

    return VTemplateNutritionPanel;
});

